export const SIDEBAR_WIDTH = {
  closed: 24,
  open: 280,
  openMdUp: 325,
};
